var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.173 447.787C378.59 489.254 318.366 512.113 256 512C114.773 512 0 397.227 0 256C0 120.107 106.24 8.74667 240 0.64V107.733C165.12 115.627 106.667 179.2 106.667 256C106.667 338.347 173.653 405.333 256 405.333C291.413 405.333 324.053 392.96 349.653 372.267L425.173 447.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.214 33.3136C349.305 14.6171 311.865 3.02398 272 0.64V107.733C282.102 108.811 292.003 110.913 301.563 113.97L382.214 33.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.231 211.072L478.989 130.321C497.508 163.1 508.989 200.35 511.36 240H404.267C403.213 230.121 401.18 220.435 398.231 211.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.787 425.173C484.693 383.787 507.947 330.453 511.36 272H404.267C401.382 300.447 390.261 327.433 372.267 349.653L447.787 425.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.817 45.37L258.299 194.899C257.546 195.654 257.01 196.597 256.746 197.63L240.172 264.149C239.929 265.136 239.944 266.169 240.216 267.149C240.488 268.129 241.008 269.022 241.726 269.742C242.829 270.841 244.322 271.459 245.879 271.46C246.36 271.46 246.838 271.401 247.304 271.283L313.823 254.708C314.858 254.448 315.802 253.912 316.555 253.157L466.086 103.638L407.817 45.37ZM503.128 24.9819L486.484 8.33871C475.36 -2.78509 455.972 -2.77405 444.861 8.33871L424.474 28.7268L482.74 86.9926L503.128 66.6051C508.684 61.0509 511.745 53.6577 511.745 45.7949C511.745 37.9321 508.684 30.5388 503.128 24.9819Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditChartIcon);
export default __webpack_public_path__ + "static/media/edit-chart-icon.3ee4495223b1999bb9528bd966ddb166.svg";
export { ForwardRef as ReactComponent };